export enum Log {
  ALL = "*",
  ERROR = "error",
  WARN = "warn",
  CHAT = "chat",
  ACCOUNT = "account",
  AGENT = "agent",
  MEMBER = "member",
  AI = "ai",
  API = "api",
  ASYNC_FMS = "async-fms",
  AUTH = "auth",
  BOT_CALLER = "bot-caller",
  BOT_CHAT = "bot-chat",
  BOT_LLM = "bot-llm",
  /** Live-assist coaching for human agents (ENG-2957). `bot-*` so it is on wherever the bot's own logs are. */
  BOT_COACHING = "bot-coaching",
  /** The Pulse Agent (ENG-3219). `bot-*` so it is on wherever the bot's own logs are. */
  BOT_PULSE = "bot-pulse",
  BRAINS = "brains",
  BULL = "BULL",
  SEQUENCES = "sequences",
  BULL_REDIS = "redis",
  CONVERSATIONS = "conversations",
  DATABASE = "database",
  EMAIL = "email",
  ESCALATIONS = "escalations",
  EVENT_BUS = "event-bus",
  FACEBOOK_MESSENGER = "facebook-messenger",
  FMS_SERVICE = "fms",
  GOOGLE = "google",
  LOCATIONS = "locations",
  MESSAGE_ROUTER = "message-router",
  MESSAGING = "messaging",
  NODE_HANDLER = "node-handler",
  NODE_ROUTER = "node-router",
  NOTIFICATIONS = "notifications",
  PAYMENT = "Payment Process",
  POSTAL_CODE_MANAGER = "postal-code-manager",
  QNODE = "qnode",
  QUESTS = "quests",
  REDIS = "redis",
  REVIEWS = "reviews",
  ROLES = "roles",
  SPOT = "spot",
  SMS = "sms",
  SMS_GROUP = "sms-group",
  SYNC_FMS = "sync-fms",
  USER_MERGE = "user-merge",
  USER_VARS = "user-vars",
  USERS = "users",
  WHATSAPP = "whatsapp",
  VOICE = "voice",
  WEBSOCKET = "websocket",
  KIEM = "kiem",
  SESSIONS = "sessions",
  VARS = "vars",
  UTIL = "util",
  CRM = "crm",
  WIDGET = "widget",
  POLICY = "policy",
  SCRAPER = "scraper"
}
